import { createQueryData } from '../helpers/createQueryData';

const { useQuery, createKey, fn } = createQueryData({
  endPoint: 'Acceptance/view_calendar_get_records_by_interval_id',
});

export const useAddressesAndClientByIntervalIdQuery = ({
  params: { intervalId, acceptanceId } = {},
  options,
} = {}) => {
  return useQuery({
    params: { intervalId, acceptanceId },
    options: { staleTime: 0, ...options },
  });
};

export const addressesAndClientByIntervalIdFetch = ({
  queryClient,
  params: { intervalId, acceptanceId },
  options,
}) => {
  return queryClient.fetchQuery(
    createKey({ intervalId, acceptanceId }),
    () => fn({ intervalId, acceptanceId }),
    options
  );
};
